module.exports = __webpack_public_path__ + "static/img/right1.4e4a479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right1.png
// module id = MYH1
// module chunks = 1